import React, { useEffect, useState } from 'react';
import { FaTag, FaFolder } from 'react-icons/fa';
import { Typography } from '@mui/material';
import { tagsApi } from '../../../../../../../services/api';
import LoadingSpinner from '../../../../../../common/LoadingSpinner';
import {
  TagsContainer,
  TagOption,
  TagIcon,
  TagCount,
  Label,
  Field,
} from './styles';

const TagTreeOption = ({ tag, level = 0, selectedTags, onToggle }) => {
  const hasChildren = tag.children && tag.children.length > 0;
  const isSelected = selectedTags.some(t => t.id === tag.id);

  return (
    <div>
      <TagOption
        selected={isSelected}
        onClick={() => onToggle(tag.id, tag.name)}
        type="button"
        style={{ marginLeft: `${level * 20}px` }}
      >
        <TagIcon>
          {hasChildren ? <FaFolder /> : <FaTag />}
        </TagIcon>
        {tag.name}
        {hasChildren && <TagCount>({tag.children.length})</TagCount>}
      </TagOption>

      {hasChildren && tag.children.map(child => (
        <TagTreeOption
          key={child.id}
          tag={child}
          level={level + 1}
          selectedTags={selectedTags}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

const NodeTags = ({ selectedTags, onTagToggle, isOpen }) => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTags = async () => {
      setLoading(true);
      try {
        const tagsData = await tagsApi.getTagHierarchy();
        setTags(tagsData);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchTags();
    }
  }, [isOpen]);

  return (
    <Field>
      <Label>Tags</Label>
      {loading ? (
        <LoadingSpinner message="Loading tags..." />
      ) : error ? (
        <Typography variant="body2" color="error">Error loading tags: {error}</Typography>
      ) : tags && tags.length > 0 ? (
        <TagsContainer>
          {tags.map(tag => (
            <TagTreeOption
              key={tag.id}
              tag={tag}
              selectedTags={selectedTags}
              onToggle={onTagToggle}
            />
          ))}
        </TagsContainer>
      ) : (
        <Typography variant="body2" color="textSecondary">No tags available</Typography>
      )}
    </Field>
  );
};

export default NodeTags;
